<template>
  <aside :class="{ active, inverted }" class="container" @wheel.stop @touchmove.stop>
    <div v-if="!full" class="background" @click="close" />
    <div class="slot" :class="{ full }">
      <mq-layout mq="md+">
        <div class="btn-close" :class="{ animated: !nested }" @click="close" v-if="full">
          <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M14.684 20.776l6.123-4.936-6.123-4.944" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10"/><path d="M16.745 30.836c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/></svg>
        </div>
        <div class="btn-close cross" @click="close" v-else>
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1 15.836c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15z" stroke="#fff" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/><path d="M20.54 11.294l-9.08 9.084M11.46 11.294l9.08 9.084" stroke="#fff" stroke-width="1.5"/></svg>
        </div>
      </mq-layout>
      <slot> </slot>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'Aside',
  props: {
    active: {
      type: Boolean,
      default: false,
      require: true
    },
    full: {
      type: Boolean,
      default: false
    },
    nested: Boolean,
    inverted: Boolean
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
aside {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  @media screen and (max-width: $mq-tablet) {
    padding-top: $drawerHeight;
  }
  overflow: hidden;
  transform: translateX(100%);
  transition: transform $animationDuration * 2 $bezier;
  color: $col-navy-dark;
  display: flex;
  flex-direction: row;
  z-index: 1000;
  &.inverted {
    color: $col-white;
    .background {
      background-color: $col-navy-dark;
    }
    .slot {
      color: $col-white;
    }
  }
  &.active {
    transform: translateX(0);
  }
  .btn-close.cross {
    top: 0;
    left: inherit;
    right: 0;
    padding: $padding/4;
    transform: inherit;
  }
  .slot {
    position: static;
    width: 70%;
    overflow-y: scroll;
    overflow-x: hidden;
    svg path {
      stroke: currentColor;
    }
    @media screen and (max-width: $mq-tablet) {
      width: 100%;
    }
    height: 100%;
    background-color: $col-white;
    &.full {
      width: 100%;
    }
  }
  .btn-close.animated {
    animation: bounce-h 1s infinite;
  }
  .btn-close svg {
    transform: scale(-1, 1);
  }
  .background {
    position: relative;
    width: 30%;
    height: 100%;
    background-color: $col-navy-dark;
    opacity: 0.5;
    @media screen and (max-width: $mq-tablet) {
      width: 0%;
    }
  }
}
</style>
